// current user hook

import { useAppSelector } from '@/hooks/redux/redux';

export const useCurrentUser = () => {
  const currentUser = useAppSelector((state) => state.userInfo.User);

  return {
    currentUser,
    userId: currentUser?.Id ?? null,
    isAuthenticated: !!currentUser?.Id
  };
};
